import { render, staticRenderFns } from "./BatchesListSkeleton.vue?vue&type=template&id=82cd372a&scoped=true"
import script from "./BatchesListSkeleton.vue?vue&type=script&lang=js"
export * from "./BatchesListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BatchesListSkeleton.vue?vue&type=style&index=0&id=82cd372a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cd372a",
  null
  
)

export default component.exports